export default __webpack_public_path__ + "static/media/KOD0036-min.493f5f43.webp";